const getUpdatedValue = (changedValue, value) => changedValue || null;

const isMatch = (plot, value) => value === null || plot.livingAreaInSquareMeters >= parseInt(value, 10);

const isSet = (value) => typeof value === 'number';

export default {
	getUpdatedValue,
	isMatch,
	isSet
};